var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.61,
    height: 22.888,
    viewBox: "0 0 28.61 22.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-5 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26097",
    "data-name": "Path 26097",
    d: "M28.064,29.888h3.5a2.3,2.3,0,0,0,0-4.578h-3.5a2.3,2.3,0,0,0,0,4.578Zm-21.02,0H21.056a2.3,2.3,0,0,0,0-4.578H7.044a2.3,2.3,0,0,0,0,4.578Zm21.02-9.155h3.5a2.177,2.177,0,0,0,2.044-2.289,2.177,2.177,0,0,0-2.044-2.289h-3.5a2.177,2.177,0,0,0-2.044,2.289A2.177,2.177,0,0,0,28.064,20.733Zm-21.02,0H21.056A2.177,2.177,0,0,0,23.1,18.444a2.177,2.177,0,0,0-2.044-2.289H7.044A2.177,2.177,0,0,0,5,18.444a2.177,2.177,0,0,0,2.044,2.289Zm0-9.155H21.056A2.177,2.177,0,0,0,23.1,9.289,2.177,2.177,0,0,0,21.056,7H7.044A2.177,2.177,0,0,0,5,9.289a2.177,2.177,0,0,0,2.044,2.289Zm21.02,0h3.5A2.177,2.177,0,0,0,33.61,9.289,2.177,2.177,0,0,0,31.567,7h-3.5A2.177,2.177,0,0,0,26.02,9.289,2.177,2.177,0,0,0,28.064,11.578Z",
    transform: "translate(0 0)",
    fill: "#0ab39c",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.49a7c95d98071a4f0a7044ccfec25d82.svg";
export { ForwardRef as ReactComponent };